import * as React from 'react';
import { FC, ReactElement } from 'react';

import { use$ } from '@legendapp/state/react';

import useEmissionLabelsSeparators from './hooks/use-efficiency-labels-separators';

import translate, { MODAL_TRANSLATION_KEY } from '../../utils/translate';
import { createHybridFueltype } from './utils/create-hybrid-fueltype';
import { createStandardFueltype } from './utils/create-standard-fueltype';

import { ENGINE_TYPES } from './types';

import { emissionStore } from '../../store';

interface EfficiencyProps {
	children?: ReactElement;
}

const Efficiency: FC<EfficiencyProps> = ({ children }) => {
	const efficiencyData = use$(emissionStore.emissionData);

	const emissionLabelsSeparators = useEmissionLabelsSeparators();
	const { modelName, deselectableEquipmentLabel } = emissionLabelsSeparators;

	if (!efficiencyData) return <>{translate(`variants.${MODAL_TRANSLATION_KEY}.disclaimerData`)}</>;

	const wltpData = efficiencyData?.wltpRangeData;
	const wltpRangeValue = wltpData?.wltp;
	const energyEfficiency = wltpData?.energyEfficiency;

	if (!wltpData || !wltpRangeValue || !energyEfficiency) {
		return null;
	}

	const isHybridVehicle = wltpData?.engineType === ENGINE_TYPES.OVC_HEV;

	const fuelTypes = !isHybridVehicle
		? createStandardFueltype({ energyEfficiency, wltpRangeValue, emissionLabelsSeparators })
		: createHybridFueltype({ energyEfficiency, wltpRangeValue, emissionLabelsSeparators });

	return (
		<>
			{[modelName, fuelTypes, deselectableEquipmentLabel].filter(Boolean).join('; ')}
			{children}
		</>
	);
};

export default Efficiency;
